// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tq-0";